import { Component, OnInit, Input } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { MenuItem } from '@models/menu-item';

@Component({
  standalone: false,
  selector: 'app-item-option',
  templateUrl: './item-option.component.html',
  styleUrls: ['./item-option.component.scss']
})
export class MenuItemOptionComponent implements OnInit {
  @Input()
  item: MenuItem;

  @Input()
  mode: number;

  constructor(
    public menuCtrl: MenuController
  ) { } 
  ngOnInit(): void { }

  toggleMenu(){
    // Aquí debe cerrar el menú
    this.menuCtrl.toggle();
  }
}
